var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavoritActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:heart-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.6002 5.14342L20.6007 5.14391C22.7639 7.31634 22.7616 10.6963 20.6035 12.8535L20.6034 12.8536L12.75 20.707L4.89653 12.8536L4.89646 12.8535C2.73811 10.6961 2.73626 7.31611 4.89528 5.14791L4.89601 5.14718C5.40126 4.63768 6.00227 4.23314 6.66447 3.95682C7.32658 3.68053 8.03679 3.53789 8.75424 3.53711C10.109 3.53722 11.4143 4.04618 12.4116 4.96316L12.7499 5.27431L13.0884 4.96321C14.0858 4.04634 15.3911 3.53739 16.7458 3.53711C17.4624 3.53769 18.1718 3.67988 18.8332 3.95552C19.4947 4.23119 20.0952 4.63489 20.6002 5.14342Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritActive);
export default __webpack_public_path__ + "static/media/favorit_active.2662147a6c8f7fcfcd0d978d9a6f16d9.svg";
export { ForwardRef as ReactComponent };